import styled from 'styled-components';

export const EmptyContainer = styled.div`
  padding: 90px 50px;
`;

export const EmptyTitle = styled.p`
  font-size: 32px;

  margin-top: 13px;
  margin-bottom: 42px;
`;
export const EmptyText = styled.p`
  font-size: 16px;
`;
